import { FormattedMessage } from 'components/shared/Intl';
import { ComponentProps } from 'react';

export function FormLoadingIndicator({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={`d-flex flex-column text-center form-loading-indicator ${className}`}
      data-e2e="form-loading-indicator"
      style={{ marginTop: '30vh' }}
      {...props}
    >
      <span className="spinner-border mb-2" />
      <FormattedMessage id="loadingPleaseWait" />
    </div>
  );
}
